import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VerificationComponent } from './components/verification/verification.component';
import { SignInComponent } from './components/signin/signin.component';
import { dtQBanGuard } from './guards/dtQBan.guard';
import { QuayBanComponent } from './components/quayban/quayban.component';
import { AcceptKeyGuard } from './guards/acceptKey.guard';
import { BanHangComponent } from './components/banhang/banhang.component';
import { GuestGuard } from './guards/auth.guard';
import { KhtvComponent } from './components/khtv/khtv.component';
import { printhdComponent } from './components/printhd/printhd.component';

const routes: Routes = [
   { path: '', component: VerificationComponent },
   { path: 'signin', component: SignInComponent, canActivate: [dtQBanGuard] },
   { path: 'nhap-ma-quay', component: QuayBanComponent, canActivate: [AcceptKeyGuard] },
   { path: 'banhang', component: BanHangComponent, canActivate: [GuestGuard] },
   { path: 'in', component: printhdComponent, canActivate: [] },
   //{ path: 'khtv', component: KhtvComponent, canActivate: [GuestGuard] }
];

@NgModule({
   imports: [
      RouterModule.forRoot(routes),
      RouterModule.forChild(routes)
   ],
   exports: [
      RouterModule
   ],
   declarations: [
   ]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts